import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import ServiceLogsFilter from "../../../elements/serviceLogs/ServiceLogsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import Notification from "../../../elements/notification/Notification";
import LogsList from "./LogsList";

import { StyledLogsWrapper } from "../../styledLogs";

const LogsContainer = ({ t }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState({
    main: false,
    fragment: false
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "currentTab": checkFilterItem(history, "currentTab", "service", false, true),
    "datetime[gte]": checkFilterItem(history, "datetime[gte]", null, true),
    "datetime[lte]": checkFilterItem(history, "datetime[lte]", null, true),
    "transactionId": checkFilterItem(history, "transactionId", null),
    "user": checkFilterItem(history, "user", null),
    "ip": checkFilterItem(history, "ip", null),
    "collection": checkFilterItem(history, "collection", null, false, false, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchLogs = () => {
    let filterUrl = fetchFilterData(filterData);

    history.replace(filterUrl);

    if (!filterData["collection"]) {
      setLogs([]);
      return;
    }

    let itemsPerPage;

    if (logs.length === 0) {
      setLoading({ main: true, fragment: false });
      itemsPerPage = 100;
    } else {
      setLoading({ main: false, fragment: true });
      itemsPerPage = 30;
    }

    axios.get("/api/app-logs/list" + filterUrl + "&itemsPerPage=" + itemsPerPage, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        let requestLogs = response.data.list;

        if (response.data.page === 1) {
          setLogs(requestLogs);
          return;
        }

        setLogs([...logs, ...requestLogs]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setLoading({ main: false, fragment: false }));
  };

  useEffect(() => {
    fetchLogs();

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [filterData]);

  useEffect(() => {
    setFilterData(prevState => ({ ...prevState, page: 1 }));
  }, []);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setFilterData({ ...filterData, page: filterData.page + 1 });
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledLogsWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <div className="logs-head">
          <ServiceLogsFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <LogsList
          loading={loading}
          logs={logs}
        />
      </StyledLogsWrapper>
    </>
  );
};

export default LogsContainer;